import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import HomeIcon from "@material-ui/icons/Home";
import styles from "./Tos.module.css";

function PrivacyPolicy(props) {
  const breadcrumbsData = [
    {
      label: "Home",
      link: "/",
      icon: <HomeIcon fontSize="small" />,
    },

    {
      label: "Terms of Use",
      link: "",
    },
  ];

  return (
    <div>
      <Header />
      <div
        style={{
          borderBottom: "1px solid rgb(235 235 235)",
          paddingTop: "22px",
        }}
      >
        <Container maxWidth="lg">
          <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        </Container>
      </div>

      <div className="Section">
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <div className={styles.TosContainer}>
                <h1 className={styles.PageTitle}>Privacy Policy</h1>
                <div className={styles.TosDate}>
                  This Privacy Policy was last updated on March 12, 2023.{" "}
                </div>
                <h2>Thank you for using Takbir!</h2>
                <p>
                  Thank you for joining us. At Takbir, we take privacy seriously
                  and we want to ensure that you are aware of how we collect,
                  use, and share data about you. Our Privacy Policy outlines our
                  data collection practices and also provides information on
                  your rights regarding your personal data. Please note that
                  unless we link to a different policy or state otherwise, this
                  Privacy Policy applies when you visit or use any of the
                  Services offered by Takbir, including our websites, mobile
                  applications, APIs, and related services.
                </p>
                <p>
                  <b style={{ color: "black" }}>
                    By using our Services, you agree to the terms set forth in
                    our Privacy Policy.
                  </b>{" "}
                  If you do not agree to this policy or any other agreements
                  that govern your use of the Services, we kindly request that
                  you refrain from using them. Thank you for choosing Takbir. We
                  look forward to providing you with exceptional service while
                  respecting your privacy.
                </p>
                <p>
                  Thank you for choosing Takbir. We look forward to providing
                  you with exceptional service while respecting your privacy.
                </p>
                {/* information collecting */}
                <h2>What information we collect:</h2>
                <p>
                  We obtain various types of information from you, including the
                  data you input, your content usage history, and information
                  from third-party platforms you link to Takbir. We also
                  automatically gather specific information about your device
                  and how you interact with our Services. The information we
                  collect about you may vary depending on how you use our
                  Services.
                </p>
                <p>
                  To provide you with a better understanding of the information
                  we gather, here are some examples:
                </p>
                <p>
                  To access certain Services, you must create an account, which
                  necessitates us collecting and retaining your email address,
                  password, and account preferences. We collect and store your
                  name, email address, password, and account preferences to
                  create an instructor account. If you use particular site
                  features, we may ask for additional information, such as your
                  occupation and government-issued ID, a photo of yourself, date
                  of birth, and phone number.
                </p>
                <p>
                  Your profile information, including photos, bio, language,
                  social media profiles, country, and other details, can also be
                  added. It will be publicly visible to others who use the
                  Services. <br /> Certain features of the Services allow for
                  public communication and content sharing, such as uploading
                  educational content, sending messages to learners or
                  instructors, posting reviews or questions, and sharing photos
                  or other contributions. Depending on where this information is
                  posted, it may be visible to others.
                </p>
                <p>
                  Additionally, when accessing content, we collect specific
                  data, such as courses, assignments, workspaces, and quizzes
                  that you have begun or completed, purchases of content or
                  subscriptions, earned certificates of completion, interactions
                  with instructors and learners, as well as any essays or
                  materials submitted for course requirements or related
                  content.
                </p>
                <p>
                  When a purchase is made, we gather specific details about it,
                  such as the customer's name, billing address, and zip code,
                  which are needed to process the order. This information may be
                  stored to streamline future orders.
                </p>
                <p>
                  To make a payment, customers must provide their payment and
                  billing information, including their name, credit card
                  information, billing address, and zip code, to our payment
                  processors. <br /> We may also require additional information
                  from payment service providers, such as the last four digits
                  of the card, to facilitate payment. For security reasons, we
                  do not collect or store sensitive cardholder data, such as
                  whole credit card numbers or card details.
                </p>
                <p>
                  If you wish to receive payments, you can link your Stripe
                  account to our services. However, you should refer to the
                  Stripe Terms of Services and Privacy Policy for more
                  information. <br /> As an instructor, when you connect a
                  payment account, we collect and use certain information,
                  including your email address, account user, address, or other
                  data necessary to send payments to your account. <br /> We
                  work with trusted third parties to collect tax information
                  required by appropriate laws, which may include residency
                  information, tax identification numbers, and other personal
                  information necessary for tax purposes.
                </p>
                <p>
                  For security reasons, we do not collect or store sensitive
                  bank account information. The collection, use, and disclosure
                  of your payment, billing, and tax information are subject to
                  the payment account provider's privacy policy and other terms
                  and conditions.
                </p>
                <p>
                  We may obtain certain details regarding your social media or
                  other online accounts that are linked to your Takbir account.
                  If you sign in to Takbir using a third-party platform such as
                  Facebook, we will request permission to retrieve specific
                  information about your other accounts. This may include your
                  name, profile photo, phone number, login email address,
                  location, the physical location of your login devices, gender,
                  date of birth, number, and friends or contact list, depending
                  on the forum or service you are using.
                </p>
                <p>
                  These platforms and services transmit information to us via
                  their APIs, and the information we receive is contingent upon
                  what you or the platform or service providers have authorized.{" "}
                  <br />
                  If you utilize our services via a third-party platform or
                  service or click on links provided by third parties, your
                  data's collection, usage, and exposure are governed by the
                  privacy policy and other contracts of that third party.
                </p>
                <p>
                  If you reach out to us for assistance or to report an issue or
                  concern, we gather and retain your contact information,
                  messages, and other data that you have provided us, including
                  but not limited to your name, email address, notes, location,
                  Takbir user ID, and transaction ID for refunds. Additionally,
                  we may collect other information about you automatically or
                  that you voluntarily provide to us. We use this information in
                  accordance with our Privacy Policy to investigate your
                  concerns and respond to your queries.
                </p>
                <p>
                  When you use our Services, we also automatically collect
                  certain information, including technical details about your
                  device or computer, such as your IP address, browser,
                  operating system, device type, domain, and other similar
                  details about platform and system types. <br /> Information on
                  your interactions with the Services, such as the content you
                  accessed, the time you spent on Pages or the Service, the
                  pages you viewed, the features you used, the search terms you
                  entered, the clicks you made, the dates and time stamps of
                  your activities, the referrers that led you to the Services,
                  and other data pertaining to your use of the Services.
                </p>
                <p>
                  Your IP address is used to estimate your general geographic
                  location, including your country, city, and geographic
                  coordinates.
                </p>
                <h2>Third-Party Data</h2>
                <p>
                  In addition to the information you provide, we may gather some
                  business contact details from third-party sources that pertain
                  to your company or potential customers if you are affiliated
                  with Takbir Business.
                </p>
                <h2>How we collect data about you</h2>
                <p>
                  The information mentioned earlier is gathered through the
                  utilization of various tracking technologies, including
                  cookies, web beacons, and similar tools. Certain tools offer
                  the option to refrain from data collection.
                </p>
                <h2>Cookies and Data Collection Tools</h2>
                <p>
                  Our platform, Takbir, utilizes cookies to collect, store, and
                  share information regarding your online activity, which
                  enables us to remember your preferences and enhance your user
                  experience.
                </p>
                <p>
                  Additionally, we may utilize transparent email pixels to
                  monitor email delivery and open rates. Our team and
                  third-party service providers may use a range of automated
                  data collection tools such as beacons, scripts, and web
                  beacons (also known as "Data Collectors") to track and collect
                  specific information related to your device or browser usage
                  when utilizing our Services. We may also combine data gathered
                  through these tools with other information we collect as
                  outlined in our Privacy Policy.
                </p>
                <h2>Why do we use data collection tools?</h2>
                <p>
                  Takbir uses the following types of tools for the following
                  purposes described:
                </p>
                <p>
                  Strictly Necessary: ​​By utilizing these data collection
                  tools, you can gain access to the Website and utilize its
                  fundamental features such as logging in or accessing content.
                  Additionally, these tools assist in securing the Website,
                  preventing fraudulent access, and identifying and thwarting
                  any inappropriate use of your account information. They are an
                  essential component for the Services to operate correctly.
                  Disabling them may cause certain sections of the site to
                  malfunction or become inaccessible.
                </p>
                <p>
                  Functional: The data collection instruments keep track of your
                  browser and preferences, enhance site functionality,
                  personalize content to suit your needs, and save settings that
                  affect how the Services appear and behave, such as your
                  preferred language or video playback volume level.
                </p>
                <p>
                  Performance: The tools for collecting data aid in the
                  measurement and enhancement of the Services by offering
                  insights on usage and performance metrics, visitor volume,
                  traffic origin, and the location of application downloads.
                  Through these instruments, we can evaluate Takbir to determine
                  the user-preferred features and content, as well as which
                  emails are being accessed.
                </p>
                <p>
                  Advertising: The tools used for gathering data enable targeted
                  advertising that is based on information we have about you,
                  including your communication, system, and usage data. This
                  information is obtained by advertising service providers
                  through tracking data, and ads may be tailored to your recent
                  or long-term activity across various websites and services. To
                  offer personalized ads, we may share an anonymous and
                  encrypted version of your email address and public content
                  from the Services with these service providers.
                </p>
                <p>
                  Social Media: Using these data collection tools, you can
                  engage in social media activities such as sharing content with
                  your friends and networks. However, these cookies have the
                  ability to monitor you or your device on other websites and
                  generate profiles of your interests, which can be used for
                  personalized advertising.
                </p>
                <p>
                  It is possible to set up your web browser to alert you when
                  there are efforts to store cookies on your device, restrict
                  the kinds of cookies permitted, or reject cookies entirely.
                  However, if you choose to do this, there is a possibility that
                  certain functions of the Services may not be accessible to you
                  or that your experience may be altered or less effective.
                </p>
                <h2>What We Use Your Data For:</h2>
                <p>
                  The information you provide is utilized by us for various
                  purposes such as offering our Services, keeping in touch with
                  you, resolving any technical problems, preventing any
                  fraudulent or abusive activities, and enhancing and upgrading
                  our Services. We maintain your information for the duration
                  necessary to accomplish the goals for which it was gathered.
                </p>
                <p>
                  The data that we gather from your usage of the Services is
                  utilized for the following reasons: <br />
                  To facilitate your involvement in educational content, issue
                  certificates of completion, display personalized content, help
                  you communicate with other users, process payments to
                  instructors and other third parties, and fulfill your requests
                  and orders for educational content, products, specific
                  services, information, or features.
                </p>
                <h2>Whom we share your data with</h2>
                <p>
                  We may disclose your personal information to third parties in
                  various situations, including but not limited to when you
                  order educational content, products, specific services,
                  information, or features.{" "}
                </p>
                <p>
                  These third parties may include faculty, other learners,
                  service providers, business partners, analytics and data
                  enrichment providers, social media platforms, promotion and
                  survey vendors, and advertising companies that help us promote
                  our services. We may also share your information in compliance
                  with security or regulatory requirements or in the event of
                  business restructuring. Additionally, we may share your
                  information in aggregated or anonymized form or with your
                  consent.
                </p>
                <h2>Privacy Policy</h2>
                <p>
                  We may provide your instructors or teaching assistants with
                  information regarding your use of educational content or any
                  requested information, to help them enhance the content for
                  you and other learners. This information may consist of
                  details like your location, browser language, device settings,
                  operating system, the website that led you to Takbir, and
                  specific actions you take on Takbir, such as browsing course
                  registrations and evaluations.
                </p>
                <h2>With other Learners and Instructors</h2>
                <p>
                  Your shared content and profile information may be visible to
                  the public, including other learners and instructors,
                  depending on your privacy settings. If you interact with an
                  instructor or teaching assistant, your information, including
                  your name, may also be publicly displayed. It's important to
                  note that any public forum such as chat rooms, message boards,
                  or newsgroups can be seen by other participants, so refrain
                  from sharing confidential or proprietary information through
                  these channels. This includes your account and profile data.
                </p>
                <h2>Service Providers and Contractors</h2>
                <p>
                  Your information may be shared with third-party companies that
                  provide services on our behalf, such as, fraud prevention,
                  abuse prevention, data analysis, marketing and advertising
                  (including retargeting advertising), courier and hosting
                  services, customer service, and support. These service
                  providers may have access to your information and are only
                  authorized to use it as instructed by us in order to fulfill
                  the Service you have requested.
                </p>
                <h2>With business partners</h2>
                <p>
                  Our services are available on various websites and platforms,
                  and we have established agreements with them to promote Takbir
                  and increase its online presence. Depending on your location,
                  we may share your account data, training data, communication
                  and support, and system data with our reliable partners
                </p>
                <h2>Continuing Education Credit Organizations</h2>
                <p>
                  In the event that you are enrolled in a course to meet your
                  continuing professional development obligation, we may
                  disclose this information to the Continuing Education Credit
                  Organization if requested.
                </p>
                <h2>With data enrichment and analytics services</h2>
                <p>
                  We utilize third-party analytics tools like Google Analytics
                  and data enrichment services such as ZoomInfo, which involve
                  the sharing of certain contact or anonymous information.
                  Anonymous data is information that has been stripped of
                  personal identifiers, like your name and email address, and
                  replaced with a token identifier. This enables vendors to
                  provide analytics services or match your information with
                  publicly available data in their database, including social
                  and contact information from other sources. Our aim in doing
                  so is to improve our communication with you by making it more
                  efficient and personalized.
                </p>
                <h2>To improve social media features</h2>
                <p>
                  When using our Services, you may encounter social media
                  features like the Facebook Like button. These features may
                  permit a third-party social media provider to obtain certain
                  data from you, including your IP address, location, and the
                  specific page you are visiting on our Services. To facilitate
                  this feature, a cookie may be set by the third party. Please
                  note that your use of these features is governed by the
                  privacy policy of the third party provider.
                </p>
                <h2>For security and legal compliance</h2>
                <p>
                  We reserve the right to share your information, including all
                  categories of data, with third parties if we believe in good
                  faith (in our sole discretion) that such disclosure is
                  necessary for the following reasons:
                </p>

                <ol>
                  <li>
                    To comply with a judicial, regulatory, or legal
                    investigation, warrant, or process;
                  </li>
                  <li>
                    To satisfy a valid subpoena, court order, or other valid
                    request;
                  </li>
                  <li>
                    To enforce our Terms of Service, Privacy Policy, and other
                    legal agreements;
                  </li>
                  <li>
                    To detect or prevent fraud, abuse, potential violations of
                    law or regulations, or security or technical issues;
                  </li>
                  <li>
                    To protect the rights, property, or safety of Takbir, our
                    users, employees, members of the public, or our Services, as
                    determined in our sole discretion;
                  </li>
                  <li>
                    To allow our auditors and legal counsel to assess our
                    obligations and rights to disclose information under this
                    Privacy Policy as required or permitted by law.
                  </li>
                </ol>
                <p>
                  If Takbir is involved in a business transaction, such as a
                  merger, acquisition, assignment, dissolution, or sale of all
                  or a portion of its assets, we may share, disclose or transfer
                  all of your information to the other organization involved in
                  that transition or change review (including due diligence).
                </p>
                <p>
                  We may use aggregated or de-identified information for any
                  purpose, and with your consent, we may share information with
                  third parties outside the scope of this Privacy Policy.
                </p>
                <h2>Security:</h2>
                <p>
                  We implement appropriate measures to protect data based on its
                  nature and sensitivity. Despite our efforts, there is always a
                  risk of unauthorized access, as with any online system. It is
                  your responsibility to safeguard your password and notify us
                  if you suspect any unauthorized activity on your account.
                </p>
                <p>
                  To ensure the security of personal information collected and
                  stored by Takbir, we take appropriate measures to prevent
                  unauthorized access, alteration, disclosure, or destruction.
                  These measures are customized to the sensitivity and nature of
                  the data.{" "}
                </p>
                <p>
                  However, no system is entirely impervious to breaches, and we
                  cannot guarantee that unauthorized parties will not have
                  access to communications between you and Takbir or the
                  information you provide through our services.{" "}
                </p>
                <p>
                  Your password plays a crucial role in our security system, and
                  it is your responsibility to protect it. You should not share
                  your password with anyone, and if you suspect any compromise
                  of your account, you should change it immediately and contact
                  our support team for assistance.
                </p>
                <h2>Your rights:</h2>
                <p>
                  You are entitled to certain rights in relation to the use of
                  your information. These rights include the ability to opt out
                  of receiving promotional emails, cookies, and data collection
                  by specific third parties. Additionally, you can manage your
                  account on our Services and reach out to us if you have any
                  requests regarding your information. If you are a parent and
                  believe that we have unintentionally collected personally
                  identifiable information about your child, please contact us
                  so that we can assist you in deleting it.
                </p>
                <p>
                  To access and modify the information collected and stored by
                  Takbir, please log in to your account and make changes as
                  needed. Please note that even if you close your account, other
                  people may still be able to view some or all of your
                  information. As per our Privacy Policy, we may retain and
                  disclose such information even after your account has been
                  closed.
                </p>
                <h2>Updates and Contact details</h2>
                <p>
                  In case there is a significant alteration to this policy, we
                  will inform users through email, in-app alerts, or any other
                  legally mandated means. Such changes will take effect from the
                  day they are made public. If you have any queries,
                  apprehensions, or disagreements, feel free to reach out to us
                  via email or postal service.
                </p>
                <h2>Changes to this Privacy Policy</h2>
                <p>
                  Our Privacy Policy may be updated periodically and in case of
                  a significant change, we will inform you through email or by
                  posting a notice on the Services. A summary of the major
                  changes will also be provided.{" "}
                </p>
                <p>
                  The changes will come into effect on the day they are posted,
                  unless stated otherwise. If you continue to use the Services
                  after the effective date of any change, you agree to be bound
                  by the revised Privacy Policy. The new policy will replace all
                  previous privacy policies, subject to applicable law.
                </p>
                <h2>Effective Date</h2>
                <p>
                  This Privacy Policy is effective as of 3/10/23. If you would
                  like further information in relation to your rights or would
                  like to exercise any of them, you may also contact us via{" "}
                  <a href="https://support.mytakbir.com/">Support Center</a>
                </p>
                {/* <h2>What Information We Collect</h2>
                <p>
                  We gather the following types of information about users
                  through the Site:
                </p>

                <ol>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                </ol> */}
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}

export default PrivacyPolicy;
